import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  tab: {
    backgroundColor: 'unset',
    overflow: 'hidden',
    padding: theme.spacing(3, 0, 0, 0)
  }
}));
